const sectionTwo = function() {
    function sectionTwo() {
        this.selector = {
            showmoreless: document.querySelectorAll('.show-more-less')
        }
        this.load();
    }
    sectionTwo.prototype.load = function() {
        var _ = this;
        if(_.selector.showmoreless.length > 0) {
            _.selector.showmoreless.forEach(el => {
                el.addEventListener('click', event => {
                    if(event.target.closest('button').classList.contains('more')) {
                        event.target.closest('button').classList.remove('more');
                        event.target.closest('button').classList.add('less');
                    } else {
                        event.target.closest('button').classList.add('more');
                        event.target.closest('button').classList.remove('less');
                    }
                    event.target.closest('.section-two-container').querySelector('.toggle-info').classList.toggle('less');
                    let expand = event.target.closest('.section-two-container').querySelector('[js-expand-container]');
                    if (event.target.closest('.section-two-container').querySelector('.toggle-info').classList.contains('less')) {
                        expand.style.maxHeight = '0px';
                    } else {
                        expand.style.maxHeight = expand.scrollHeight + 'px';
                    }
                })
            })
        }
    }
    sectionTwo = new sectionTwo;
}
sectionTwo();